import {Placement} from 'common/components/tooltip/types';

const LEARN_MORE_LINK = `\n[Learn More](https://help.mixpanel.com/hc/en-us/articles/13271005313556#view-n-segments)`;

export const SORTING_TOOLTIP = {
  text: `Set the grouped or ungrouped\nsort order. [Learn More](https://help.mixpanel.com/hc/en-us/articles/13271005313556#sort-order)`,
  placement: Placement.Bottom,
};

export const GROUPED_SORTING_TOOLTIP = {
  text: `You are seeing top performing segments\nUncheck this option to show top metric values${LEARN_MORE_LINK}`,
};

export const FLAT_SORTING_TOOLTIP = {
  text: `You are seeing top metric values.\nCheck this option to show top performing segments${LEARN_MORE_LINK}`,
};
